import script from "./ProjectsSort.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsSort.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsSort.vue?vue&type=style&index=0&id=5a286f6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a286f6d"]])

export default __exports__